'use client'

import { createContext, useContext } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { usePlannerEvents } from '@/hooks/usePlannerEvents'

type PlannerEventContextValue = ReturnType<typeof usePlannerEvents>

const PlannerEventContext = createContext<PlannerEventContextValue | null>(
  null
)

export function PlannerEventProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const { user, token } = useAuth()
  const value = usePlannerEvents(user?.id, token ?? null)
  return (
    <PlannerEventContext.Provider value={value}>
      {children}
    </PlannerEventContext.Provider>
  )
}

export function usePlannerEvent(): PlannerEventContextValue {
  const ctx = useContext(PlannerEventContext)
  if (!ctx) {
    throw new Error('usePlannerEvent must be used within PlannerEventProvider')
  }
  return ctx
}
